import Model from './Model'

export default class Quote extends Model {
  resource()
  {
    return 'quotes'
  }
}